window.$ = window.jQuery = require('jquery');

window.FontAwesomeConfig = { autoReplaceSvg: false };
require('@fortawesome/fontawesome-free/js/all');
require('slick-slider/slick/slick');

var geolocator = require('geolocator');
var googleKEY = $("#GOOGLE_KEY").val();

geolocator.config({
    language: "it",
    google: {
        version: "3",
        key: googleKEY
    }
});

function contactsMap() {
    var latlng1 = new google.maps.LatLng(45.5196118, 9.2091287);
    var map_contacts = new google.maps.Map(
        document.getElementById('map-contacts'), {zoom: 12, center: latlng1, mapTypeControl: false, zoomControl: false, fullscreenControl: false, streetViewControl: false, gestureHandling: 'none'});
    var marker1 = new google.maps.Marker({position: latlng1, map: map_contacts});
}

function dealerMap() {
    require('./markerclusterer');

    var center = new google.maps.LatLng(45.5196118, 9.2091287);

    var map = window.map;
    map.setZoom(9);
    map.setCenter(center);

    var markers = [];

    var infoWindow = new google.maps.InfoWindow();

    $(".single-dealer").each(function () {

        var name    = $(this).find(".name-dealer").html();
        var address = $(this).find(".address-dealer").html();
        var phone   = $(this).find(".phone-dealer").html();
        var mail    = $(this).find(".mail-dealer").html();
        var site    = $(this).find(".link-dealer").html();
        var url     = $(this).find('#name-dealer-url').attr("href");

        var special = $(this).data('is-special');

        var markerTemplate = "" +
            "<div class='info-pin-google'>" +
            "<div class='info-pin-name'><a href='"+url+"'> "+name+" </a></div>" +
            "<div class='info-pin-address'>"+address+"</div>" +
            "<div class='info-pin-phone'><i class='fas fa-phone'></i><a href='tel:'" + phone + "'>"+phone+"</a></div>" +
            "<div class='info-pin-mail'><i class='fas fa-envelope'></i><a href='mailto:'" + mail + "'>"+mail+"</a></div>";

        if(site !== undefined){
            markerTemplate += "<div class='info-pin-mail'><i class='fas fa-globe'></i><a href='" + "//" +site+ "'>" +site+ "</a></div> </div>";
        }else{
            markerTemplate += "</div>";
        }

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng($(this).data("latitude"), $(this).data("longitude"))
        });

        if (special) {
            marker.setIcon('images/marker/pin_map_blue.png');
        } else {
            marker.setIcon('images/marker/pin_map_grey.png');
        }

        google.maps.event.addListener(marker, 'click', function () {
            var markerContent = markerTemplate;
            infoWindow.setContent(markerContent);
            infoWindow.open(map, this);
            var latLng = this.getPosition();
            map.setCenter(latLng);
        });
        markers.push(marker);
    });

    google.maps.event.addListener(map, 'zoom_changed', function() {
        showDealersForVisibleMarkers(markers);
    });

    google.maps.event.addListener(map, 'center_changed', function() {
        showDealersForVisibleMarkers(markers);
    });

    var options = {
        imagePath: 'images/marker/m',
        minimumClusterSize: 9999, //da togliere quando si vuole abilitare il raggruppamento dei markers
    };

    var markerCluster = new MarkerClusterer(map, markers, options);
}

function showDealersForVisibleMarkers(markers) {
    var n = 0;
    for (var i=0; i<markers.length; i++){
        var lat = markers[i].getPosition().lat().toFixed(8);
        var lng = markers[i].getPosition().lng().toFixed(8);
        if( map.getBounds().contains(markers[i].getPosition()) ){
            $('.single-dealer[data-latitude="'+lat+'"][data-longitude="'+lng+'"]').show();
            n+=1;
        } else {
            $('.single-dealer[data-latitude="'+lat+'"][data-longitude="'+lng+'"]').hide();
        }
    }
    $("#dealers-count").html(n.toString());
}

function localizeMe() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            var geocoder = window.geocoder;
            var myLatlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
            if (geocoder) {
                geocoder.geocode({
                    'location': myLatlng
                }, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
                            $("#address").val(results[0].formatted_address);
                        }
                    }
                });
            }
        });
    }
}

function initializeMapWithAddress() {
    var addressInput = $("#address");
    var address = addressInput.val();
    var radius = addressInput.data('radius');

    searchAddress(address, radius);
}

function searchAddress(address, radius) {
    var geocoder = window.geocoder;
    var map = window.map;

    if (geocoder) {
        geocoder.geocode({
            'address': address
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
                    var center = results[0].geometry.location;
                    map.setCenter(center);

                    circle.setMap(null);

                    if ($(input).data("has-circle")) {
                        circle = window.mapCircle(center, radius);
                    }

                    map.setZoom(12);
                }
            }
        });
    }
}

$('.hamburger').on('click', function () {
    //Evento che al click aggiunge la classe active al menu Hamburger
    var $this = $(this);
    $('body').toggleClass('menu-open');
    $(this).toggleClass('is-active');
    $('.menu-list').toggleClass('close-menu');

});

function init() {
    var searchedAddressKey = "searchedAddressKey";
    var searchBtn = $("#address-search");
    var addressInput = $("#address");

    if (document.getElementById('map-contacts') !== null) {
        contactsMap();
    }
    if (document.getElementById('address-map') !== null) {
        if ($(".map-input")[0]) {
            require('./map');
            window.mapInitialize();
        }
        dealerMap();
    }
    $(".localize-me").click(localizeMe);
    $(".alert-success").delay(3500).fadeOut();
    $(".invalid-feedback").delay(6000).fadeOut();

    addressInput.on('keyup', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            $("#address-search")[0].click();
        }
    });

    searchBtn.click(function (){
        if (addressInput.val().trim() != "" && document.getElementById("index-address")) {
            localStorage.setItem(searchedAddressKey, $("#address").val());
        }
    });
    if (document.getElementById("dealer-locator-address")) {
        searchBtn.click(function (e){
            e.preventDefault();
            var address = addressInput.val();
            searchAddress(address, addressInput.data('radius'));
        });

        if (localStorage.getItem(searchedAddressKey)) {
            addressInput.val(localStorage.getItem(searchedAddressKey));
            localStorage.removeItem(searchedAddressKey);

            google.maps.event.addDomListener(window, 'load', initializeMapWithAddress);
        }
    }

}

$(document).ready(function(){
    init();
    $('.content-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 1392,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        prevArrow: $('.arrow-left'),
        nextArrow: $('.arrow-right')
    });

    // using CommonJS modules
    var lozad = require('lozad')
    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
});
